import { Typography } from '@mui/material';
import { ReactNode } from 'react';

import styles from './DiffHeader.module.scss';


interface DiffHeaderProps {
    header: ReactNode;
    hideUnchanged?: boolean;
}

export function DiffHeader({ header, hideUnchanged }: DiffHeaderProps) {
    return hideUnchanged ? null : (
        <Typography
            fontWeight={500}
            color="textSecondary"
            className={styles.root}
        >
            {header}
        </Typography>
    );
}
